import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ASSET_ROUTE_URL } from '../../../constants/routes';
import { ProductType } from '../../../hooks/useProducts';
import { Divider } from '../../catalyst-ui-kit/divider';
import { TradeCharts } from '../TradeCharts/TradeCharts';
import { TradeFooter } from '../TradeFooter/TradeFooter';
import { TradeForm } from '../TradeForm';
import { TradeHeader } from '../TradeHeader/TradeHeader';
import { TradeOrderbookTabs } from '../TradeOrderbookTabs/TradeOrderbookTabs';
import { MobileViewSwitcher } from './MobileViewSwitcher';

type TradePageMobileProps = {
  product: ProductType;
};

export function TradePageMobile({ product }: TradePageMobileProps) {
  const { mobileTab } = useSearch({ from: ASSET_ROUTE_URL });
  const navigate = useNavigate({ from: ASSET_ROUTE_URL });

  const setTab = (tab: 'chart' | 'trade') => {
    void navigate({ search: (prev) => ({ ...prev, mobileTab: tab }) });
  };

  const isChartView = mobileTab === 'chart';

  // Reset scroll to top when switching between tabs
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [mobileTab]);

  return (
    <div className="flex grow flex-col">
      <TradeHeader product={product} />
      <TradeCharts className={isChartView ? '' : 'hidden'} product={product} />
      {isChartView ? (
        <>
          <Divider className="mt-4" />
          <TradeOrderbookTabs className="px-2" />
        </>
      ) : (
        <>
          <TradeForm product={product} />
          <TradeFooter product={product} />
        </>
      )}
      <MobileViewSwitcher tab={mobileTab} product={product} onTabChange={setTab} />
    </div>
  );
}
